import { Component, OnInit } from '@angular/core';
import { PasswordService } from '../../services/password/password.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { TermsAndConditionsDialogComponent } from '../terms-and-conditions-dialog/terms-and-conditions-dialog.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  isExistingUser : boolean;
  DocListErr: boolean;
  DocListErrMsg: string;
  userid: any;
  errMessage: any;
  successMessage: any;
  ConfirmNewPassword: any;
  disableChangePwd: boolean = false;
  termsAndConditionsCheckbox: boolean = false;
  strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})');
  passwordData = {
    oldpwd: '',
    newpwd: '',
  };

  constructor(private passwordService: PasswordService, private route: ActivatedRoute, private router: Router, private dialog: MatDialog) { }

  ngOnInit() {
    this.userid = localStorage.getItem('userId');
    this.route.queryParams
      .subscribe(params => {
        // Defaults to 0 if no query param provided.
        this.isExistingUser = params['isExistingUser'];
      });
  }
  openDialog(): void {
    const dialogRef = this.dialog.open(TermsAndConditionsDialogComponent, {
      disableClose: true,
      width: '90%',
      height: '80%',
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  ConfirmPassword() {
    if (this.passwordData.newpwd && this.passwordData.oldpwd) {
      if (this.strongRegex.test(this.passwordData.newpwd)) {
        if (this.passwordData.newpwd === this.ConfirmNewPassword) {
          if((this.termsAndConditionsCheckbox == false && this.isExistingUser.toString() === 'true') || (this.termsAndConditionsCheckbox == true)){
            this.passwordService.changePassword(this.passwordData, this.userid).subscribe((res) => {
            if (res.Status == 200) {
              this.successMessage = 'Password change Successful';
              this.errMessage = '';
              this.disableChangePwd = true;
            }
          }, err => {
            if (err === 'Bad Request') {
              this.errMessage = 'User not valid';
            } else {
              this.DocListErrMsg = 'Site Admin Updation' + err;
              this.DocListErr = true;
            }
          });
          }
          else{
            this.errMessage = 'Please agree to terms and conditions';
          }
        } else {
          this.errMessage = 'Confirm password should match with new password';
        }
      } else {
        this.errMessage = 'Password should contain 8 characters , a combination of upper and lower case letters and at least one number and a special character.';
      }
    } else {
      this.errMessage = 'Invalid Old Password or New Password - please validate and re-enter.';
    }
  }
  backToLogin() {
    this.router.navigate(['/home']);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/change-password/change-password.component.ts